export default __webpack_public_path__ + "static/media/russia.573ae534.svg";